export const PROPERTY_LISTING_PAGE_SIZE = 16;
